import { render, staticRenderFns } from "./WpMetaQueryComponent.vue?vue&type=template&id=e117071c&"
import script from "./WpMetaQueryComponent.vue?vue&type=script&lang=ts&"
export * from "./WpMetaQueryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WpMetaQueryComponent.vue?vue&type=style&index=0&id=e117071c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports